// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2Go3R","footer":"ModalCreateQualiphyProcedure_footer__1Zn38","additionData":"ModalCreateQualiphyProcedure_additionData__232r3"};